// Mock clock: real time plus a stored offset, so the test panel's
// "move the clock forward" can exercise cooling periods, caps and lockouts
// without waiting. Every time-based rule in the mock uses mockNow().
import type { MockDb } from './db';

export const mockNow = (db: MockDb): number => Date.now() + db.limits.clockOffsetMs;

export const mockToday = (db: MockDb): string => {
  const d = new Date(mockNow(db));
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

/** Formats like "29 Sep, 4:30 PM" for limit lines and chips. */
export const formatShort = (ts: number): string => {
  const d = new Date(ts);
  const day = d.getDate();
  const month = d.toLocaleString('en-IN', { month: 'short' });
  const time = d.toLocaleString('en-IN', { hour: 'numeric', minute: '2-digit', hour12: true });
  return `${day} ${month}, ${time}`;
};

/** Formats like "29 Sep 2026, 4:07 PM" for receipts and profile. */
export const formatLong = (ts: number): string => {
  const d = new Date(ts);
  const day = d.getDate();
  const month = d.toLocaleString('en-IN', { month: 'short' });
  const year = d.getFullYear();
  const time = d.toLocaleString('en-IN', { hour: 'numeric', minute: '2-digit', hour12: true });
  return `${day} ${month} ${year}, ${time}`;
};

/** Formats like "4:37 PM" (activation time message). */
export const formatTimeOnly = (ts: number): string =>
  new Date(ts).toLocaleString('en-IN', { hour: 'numeric', minute: '2-digit', hour12: true });
